import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { CITY_AERIAL } from "./assets";
import { useLang } from "./LanguageContext";
import GlitchText from "./GlitchText";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error(t("newsletter.toastError"));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/wishlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, language: lang }),
      });
      const data = await res.json();
      if (res.ok && data.status === "success") {
        toast.success(t("newsletter.toastSuccess"));
        setEmail("");
      } else if (data.status === "exists") {
        toast(t("newsletter.toastExists"));
        setEmail("");
      } else {
        toast.error(t("newsletter.toastFail"));
      }
    } catch (err) {
      toast.error(t("newsletter.toastFail"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" data-testid="newsletter-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={CITY_AERIAL} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-[#060A14]/85" />
        <div className="absolute inset-0 stars opacity-50" />
      </div>

      <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
        <p className="text-[#00F2FE] text-xs font-bold tracking-[0.3em] mb-5">{t("newsletter.overline")}</p>
        <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight mb-6">
          {t("newsletter.headingPre")} <GlitchText className="glitch-title text-[#00F2FE]">{t("newsletter.headingGlitch")}</GlitchText>
        </h2>
        <p className="text-slate-400 text-sm md:text-base mb-10 max-w-lg mx-auto leading-relaxed">{t("newsletter.body")}</p>

        <form onSubmit={onSubmit} noValidate data-testid="newsletter-form" className="flex flex-col sm:flex-row items-stretch gap-4 max-w-xl mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@akayori.gg"
            data-testid="newsletter-email-input"
            className="flex-1 bg-transparent border-b-2 border-white/20 focus:border-[#00F2FE] focus:outline-none text-lg md:text-xl py-3 text-white placeholder:text-slate-600 font-mono-x text-center sm:text-left transition-colors"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="group bg-[#00F2FE] text-[#060A14] uppercase tracking-widest text-sm font-bold px-8 py-4 rounded-sm flex items-center justify-center gap-3 hover:bg-white shadow-[0_0_24px_rgba(0,242,254,0.4)] transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? t("newsletter.sending") : t("newsletter.notify")}
            {!loading && <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
